<!-- Modal -->
<div *ngIf="showMailVerificationMenu" class="modal-dialog modal-dialog-centered mail-modal">
    <div class="modal-content">
        <div class="modal-body">
            <div class="profile-section">
                <div class="profile-outer">
                    <div class="lockicon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="43" height="34" viewBox="0 0 43 34" fill="none">
                            <path fill-rule="evenodd" clip-rule="evenodd"
                                d="M25.5485 4.61556e-07H16.7016C13.735 -2.12051e-05 11.3843 -4.29079e-05 9.5072 0.190927C7.58398 0.386555 5.9784 0.796012 4.57392 1.73446C3.45018 2.48532 2.48532 3.45018 1.73446 4.57392C0.796012 5.9784 0.386555 7.58398 0.190927 9.5072C-4.29079e-05 11.3843 -2.12051e-05 13.7349 4.61556e-07 16.7015V16.8818C-2.12051e-05 19.8484 -4.29079e-05 22.199 0.190927 24.0762C0.386555 25.9993 0.796012 27.6048 1.73446 29.0095C2.48532 30.1331 3.45018 31.0979 4.57392 31.8489C5.9784 32.7873 7.58398 33.1968 9.5072 33.3924C11.3843 33.5833 13.7349 33.5833 16.7015 33.5833H25.5485C28.5151 33.5833 30.8657 33.5833 32.7429 33.3924C34.666 33.1968 36.2715 32.7873 37.6762 31.8489C38.7998 31.0979 39.7646 30.1331 40.5156 29.0095C41.454 27.6048 41.8635 25.9993 42.0591 24.0762C42.25 22.199 42.25 19.8484 42.25 16.8818V16.7015C42.25 13.7349 42.25 11.3843 42.0591 9.5072C41.8635 7.58398 41.454 5.9784 40.5156 4.57392C39.7646 3.45018 38.7998 2.48532 37.6762 1.73446C36.2715 0.796012 34.666 0.386555 32.7429 0.190927C30.8657 -4.29079e-05 28.5151 -2.12051e-05 25.5485 4.61556e-07ZM9.02276 9.27654C9.58341 8.57573 10.606 8.46211 11.3068 9.02276L17.4029 13.8996C18.3944 14.6928 19.0541 15.2187 19.6001 15.579C20.1227 15.9241 20.4254 16.0372 20.6702 16.0788C20.9712 16.1302 21.2788 16.1302 21.5798 16.0788C21.8246 16.0372 22.1273 15.9241 22.6499 15.579C23.1959 15.2187 23.8557 14.6928 24.8471 13.8996L30.9433 9.02276C31.644 8.46211 32.6666 8.57573 33.2273 9.27654C33.7879 9.97735 33.6743 10.9999 32.9734 11.5606L26.8212 16.4825C25.9008 17.2189 25.1253 17.8392 24.4407 18.2912C23.7187 18.7679 22.9851 19.1362 22.1254 19.2827C21.4632 19.3956 20.7868 19.3956 20.1246 19.2827C19.2649 19.1362 18.5313 18.7679 17.8094 18.2912C17.1247 17.8392 16.3493 17.2189 15.4288 16.4825L9.27654 11.5606C8.57573 10.9999 8.46211 9.97735 9.02276 9.27654Z"
                                fill="#162642" />
                        </svg>
                    </div>
                </div>
            </div>
            <div class="mail-verfication-wrap" id="step1" *ngIf="shouldShowProfileDetailsStep()">
                <h3>Enter details to proceed</h3>
                <p>To receive notifications about purchases, sales, or negotiations, please fill in the details below.
                </p>
                <form [formGroup]="emailForm" (ngSubmit)="onSubmit()">
                    <div class="form-group">
                        <label for="">First name.<span class="text-danger">*</span></label>
                        <input type="text" class="form-control" placeholder="Ex: John" formControlName="first_name"
                            [ngClass]="{ 'is-invalid': submitted && f['first_name'].errors }">
                        <div class="input--error"
                            *ngIf="(f &&f['first_name'].touched || submitted) &&f&& f['first_name']?.errors?.['required']">
                            First name is required.*
                        </div>
                        <div class="input--error"
                            *ngIf="(f['first_name'].touched || submitted) && f['first_name'].errors?.['invalidName']">
                            {{ f['first_name'].errors?.['invalidName'] }}
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="">Last name.<span class="text-danger">*</span></label>
                        <input type="text" class="form-control" placeholder="Ex: Doe" formControlName="last_name"
                            [ngClass]="{ 'is-invalid': submitted && f['last_name'].errors }">
                        <div class="input--error"
                            *ngIf="(f &&f['last_name'].touched || submitted) &&f&& f['last_name']?.errors?.['required']">
                            Last name is required.*
                        </div>
                        <div class="input--error"
                            *ngIf="(f['last_name'].touched || submitted) && f['last_name'].errors?.['invalidName']">
                            {{ f['last_name'].errors?.['invalidName'] }}
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="">Email Address.<span class="text-danger">*</span></label>
                        <input type="text" class="form-control" formControlName="email" placeholder="Ex: john@mail.com"
                            [ngClass]="{ 'is-invalid': submitted && f['email'].errors }">
                        <div class="input--error"
                            *ngIf="(f &&f['email'].touched || submitted) && f&&f['email'].errors?.['required']">
                            Email is required.*
                        </div>
                        <div class="input--error"
                            *ngIf="(f&& f['email'].touched || submitted) && f&&f['email'].errors?.['forbidUppercase']">
                            Capital letters not allowed.*
                        </div>
                        <div class="input--error"
                            *ngIf="(f&& f['email'].touched || submitted) && f&&f['email'].errors?.['email']">
                            Enter valid email address.*
                        </div>
                    </div>

                    <!-- Checkbox : Privacy Policy and Agreement (SIGNATURE REQUIRED) -->
                    <div class="form-group mb-3">
                        <label>
                            <input type="checkbox" [checked]="is_Checked['agreement_checkbox']"
                                (click)="triggerSignatureRetrieval($event)">
                            <span class="pl-2">I agree to the
                                <a rel="noopener" target="_blank"
                                    href="{{docUrl?.['privacy-policy_url']}}" class="text-decoration-underline">privacy policy</a>
                                and
                                <a target="_blank" rel="noopener"
                                    href="{{docUrl?.['user-agreement_url']}}" class="text-decoration-underline">terms of
                                    service</a>.
                            </span>
                        </label>
                        <div class="signature-container" *ngIf="isPendingSignature">
                            <div class="alert-signature ">
                                <div class="flex">
                                    <div class="flex-shrink-0">
                                        <svg aria-hidden="true" fill="currentColor" viewBox="0 0 20 20"
                                            xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 alert-svg">
                                            <path clip-rule="evenodd"
                                                d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
                                                fill-rule="evenodd"></path>
                                        </svg>
                                    </div>
                                    <div class="alert-prompt-wrap">
                                        <span class="text-sm text-yellow-700 blink-soft">
                                            A signing request is pending. Please open
                                            MetaMask to review
                                            and complete the
                                            process.
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="d-flex gap-3 flex-wrap"
                        [ngClass]="{'justify-content-center':isCancelOption , 'justify-content-between':!isCancelOption}">
                        <button type="button" (click)="closeStepOne()" class="onboard_cancel" data-bs-dismiss="modal"
                            *ngIf="!isCancelOption">Cancel.</button>
                        <button [disabled]="submitted || emailForm.invalid"
                            [ngClass]="{'disabled':submitted || emailForm.invalid}" type="submit"
                            class="onboard_verify">{{submitted
                            ?'Processing...':'Verify
                            Email'}}</button>
                    </div>
                </form>
            </div>
            <div class="mail-verfication-wrap" id="step2" *ngIf="shouldShowPendingVerificationStep()">
                <h3>Check your email</h3>
                <p>We have sent you an email to verify. Check your inbox for more information about the verification.
                </p>
                <form>
                    <div class="form-group position-relative">
                        <label for="">Email Address</label>
                        <input type="text" class="form-control" [value]="user['email']" readonly>
                    </div>
                    <p>Didn't receive the email? <a class="cursor-pointer" [class.disabled]="isDisabled"
                            [attr.disabled]="isDisabled ? true : null" (click)="resendVerificationEmail()">Resend
                            mail.</a></p>
                    <a *ngIf="!isEmailVerificationPending()" class="onboard_cancel d-block text-center"
                        (click)="closeModalOnly()">Close.</a>
                </form>
            </div>
            <div class="mail-verfication-wrap" id="step3" *ngIf="showStepThree">
                <div class="text-center">
                    <img src="assets/images/success-3.svg" alt="success" width="90" height="90" class="mb-3">
                </div>
                <h3>Account verified.</h3>
                <p>Your account has been successfully verified. You can now enjoy full access to all features.</p>
                <div class="pt-4">
                    <a (click)="closeModalVerification()" class="onboard_cancel d-block text-center">Close.</a>
                </div>
            </div>
        </div>
    </div>
</div>
<div *ngIf="!showMailVerificationMenu" class="modal-dialog modal-dialog-centered emailnewsletter-modal">
    <div class="modal-content">
        <div class="modal-head">
            <div class="profile-section">
                <div class="profile-outer">
                    <div class="notification-icon">
                        <img src="assets/images/notification-icon.svg" />
                    </div>
                </div>
            </div>
            <div class="mailnewsletter-head">
                <h3>Email Notifications.</h3>
                <p>
                    Select which updates you'd like to receive. You can change these anytime from your email
                    preferences.
                </p>
                <!-- <div class="d-flex justify-content-end">
                    <button type="button" class="select-all-btn" (click)="selectAll()">
                        {{ checkSelectAll() ? "Unselect All" : "Select All" }}
                    </button>
                </div> -->
                <button type="button" class="btn-closed" (click)="closeSettingsModal()">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M19 5L5 19M5 5L19 19" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                            stroke-linejoin="round"></path>
                    </svg>
                </button>
            </div>
        </div>
        <div class="modal-body">
            <div class="accordion" id="emailAccordion">
                <ng-container *ngFor="let group of emailPreferences; let i = index" [formGroup]="emailSettingsForm">
                    <div class="accordion-item">
                        <h2 class="accordion-header p-3" [id]="'heading' + i">
                            <button class="accordion-button collapsed bg-transparent shadow-none p-0" type="button"
                                data-bs-toggle="collapse" [attr.data-bs-target]="'#collapse' + i" aria-expanded="false"
                                [attr.aria-controls]="'collapse' + i">
                                {{ group.group }}
                            </button>
                            <p class="mb-0 mt-1">{{ group.describe }}</p>
                        </h2>
                        <div [id]="'collapse' + i" class="accordion-collapse collapse"
                            [attr.aria-labelledby]="'heading' + i" data-bs-parent="#emailAccordion">
                            <div class="accordion-body">



                                <div *ngFor="let item of group.items"
                                    class="d-flex align-items-center justify-content-between mb-3">
                                    <div>
                                        <h5 class="mb-1">{{ item.name }}</h5>
                                        <p class="mb-0">{{ item.description }}</p>
                                    </div>
                                    <div>
                                        <label class="switch">
                                            <input type="checkbox" [formControlName]="item.key"
                                                (change)="checkSelectAll()">
                                            <span class="slider round"></span>
                                        </label>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </ng-container>
            </div>
        </div>

        <div class="d-block text-center modal-footer">
            <div class="row row-gap-3">
                <!-- <div class="col-12 col-sm-5">
                    <button class="border-0 cancel-btn" (click)="closeSettingsModal()">Cancel</button>
                </div> -->
                <div class="col-12 col-sm-6">
                    <button type="button" class="border-0 save-btn" (click)="selectAll()">
                        {{ checkSelectAll() ? "Unselect All" : "Select All" }}
                    </button>
                </div>
                <div class="col-12 col-sm-6">
                    <button class="border-0 save-btn" [ngClass]="{'disabled': apiProcessing}" [disabled]="apiProcessing"
                        (click)="saveSettings()">
                        {{apiProcessing ? 'Processing...' : 'Save Changes.'}}</button>
                </div>
            </div>
        </div>
    </div>
</div>
